var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-prompt",
      attrs: {
        show: _vm.show,
        title: _vm.modalTitle,
        saveButton: {
          title: "Ok",
          btnClass: {
            "btn btn-main btn-rounded btn-sm z-depth-0": true,
            disabled: !this.input,
          },
        },
        cancelButton: {
          title: "Cancelar",
          btnClass: {
            "btn btn-outline-main btn-rounded btn-outline btn-sm z-depth-0": true,
          },
        },
        size: "small",
        needHeader: false,
        relativeBackdrop: true,
        contentCentered: true,
      },
      on: { close: _vm.closeModal, save: _vm.submitDialogForm },
    },
    [
      _c(
        "form",
        {
          staticClass: "dg-form",
          attrs: { autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitDialogForm.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { attrs: { for: "dg-input-elem" } }, [
            _vm._v(_vm._s(_vm.promptHelpText)),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.input,
                expression: "input",
                modifiers: { trim: true },
              },
            ],
            ref: "inputElem",
            staticStyle: {
              width: "100%",
              "margin-top": "10px",
              padding: "5px 15px",
              "font-size": "16px",
              "border-radius": "4px",
              border: "2px solid #eee",
            },
            attrs: {
              type: "text",
              placeholder: "",
              autocomplete: "off",
              id: "dg-input-elem",
            },
            domProps: { value: _vm.input },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.input = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }